import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const ROLES_FEATURE_GROUP: FeatureGroup = {
  guid: 'b4e91a2c-7d83-4f56-a012-3c8e9f7b0100',
  name: 'roles',
  description: 'Role management features — view, create, edit, and delete roles',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
